import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable} from 'rxjs';
import { InitiativesSettingsService } from 'src/app/core/services/initiatives-settings.service';

@Injectable()
export class InitiativesSettingsResolver implements Resolve<boolean> {

/* ------------------------------- Constructor ------------------------------ */

  constructor(private initiativesSettingsService: InitiativesSettingsService){

  }

/* ---------------------------- Resolve Functions --------------------------- */

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
   return this.initiativesSettingsService.getInitiativesSettings();
  }
}
